<template>
  <div class="program">
    <app-loading class="flow" :loading="loading">
      <StepsBar/>

      <div class="heading">
        <div class="buttons">
          <app-btn
            v-if="selectedStep != 'general-settings'"
            styling="inline"
            @click="$store.dispatch('program/steps/goToPrevStep')"
          >
            {{ $ml.get(`Previous`) }}
          </app-btn>
          <app-btn
            :loading="loadingbtn"
            :disabled="

            (!isNextStepAvailable && !(selectedStep == 'general-settings')) ||
            (selectedStep == 'general-settings' && (!generalSettings.farmId ||
                                                    !generalSettings.fieldId ||
                                                    !generalSettings.baseCropId ||
                                                    !generalSettings.cropYieldGoalId ||
                                                    !generalSettings.cropVarietyId ||
                                                    !generalSettings.cropGrowingMethodId )) ||
            (selectedStep != 'fertigation' && $store.getters['program/fertigation/getTanks']) ||
            selectedStep == 'result' || 
            $store.getters['user/plan'] == 'impact'"
            @click="nextStep"
          >
            {{ $ml.get(`Next`) }}
          </app-btn>
          <!-- <app-btn styling="inline" @click="close()">
            {{ $ml.get(`close`) }}
          </app-btn> -->
        </div>
      </div>


      <div class="steps" v-if="program.id">
        <transition :name="transition" mode="out-in">
          <general-settings v-if="selectedStep === 'general-settings' || selectedStep == null" :isNextStepAvailable='isNextStepAvailable'/>
          <tests v-else-if="selectedStep === 'tests'" />
          <gdd v-else-if="selectedStep === 'gdd'" />
          <liming v-else-if="selectedStep === 'liming'" />
          <base-dressing v-else-if="selectedStep === 'base-dressing'" />
          <adjusted-values v-else-if="selectedStep === 'adjusted-values'" />
          <fertilizer-schedule v-else-if="selectedStep === 'fertilizer-schedule'" />
          <fertigation v-else-if="selectedStep === 'fertigation'" />
          <blend v-else-if="selectedStep === 'blend'" />
          <result v-else-if="selectedStep === 'result'" />
        </transition>
      </div>
    </app-loading>
  </div>
</template>

<script>
import GeneralSettings from '@/components/program/program-steps/general-settings/GeneralSettings'
import Tests from '@/components/program/program-steps/tests/Tests'
import Gdd from '@/components/program/program-steps/gdd/Gdd'
import Liming from '@/components/program/program-steps/liming/Liming'
import AdjustedValues from '@/components/program/program-steps/adjust/AdjustedValues'
import BaseDressing from '@/components/program/program-steps/base-dressing/BaseDressing'
import Fertigation from '@/components/program/program-steps/fertigation/Fertigation'
import FertilizerSchedule from '@/components/program/program-steps/schedule/FertilizerSchedule'
import Blend from '@/components/program/program-steps/blend/Blend'
import Result from '@/components/program/program-steps/result/Result'
import StepsBar from '@/components/program/StepsBar'
import { ErrorHandlerMixin } from '@/mixins/error-handler.mixin'
import { mapGetters } from 'vuex';

export default {
  mixins: [ ErrorHandlerMixin ],
  data() {
    return {
      transition: 'fade-move-left',
      loading: false,
      loadingbtn: false,
    }
  },
  methods: {
    close () {
      this.$router.push({ path: 'list' });
    },

    sync(program_id) {
      this.loading = true;
      return this.$store.dispatch('program/loadProgramById', program_id)
        .then(res => {
          if(this.program.finished == 1 && this.program.currentStep != 'result')
            this.$store.commit('program/steps/setCurrentStep', 'result');
          this.$store.dispatch('program/steps/goToStep', this.currentStep || 'general-settings');
        })
        .finally(() => {
          this.loading = false;
        });

    },
    nextStep(){
      if(this.isNextStepAvailable){
        this.$store.dispatch('program/steps/goToNextStep');
        return;
      }
      if(this.selectedStep == 'general-settings'){
        this.loadingbtn=true;
        this.$store.dispatch('program/general-settings/save')
          .then(() => {
            this.$store.dispatch('program/canGoToNextStep', true);
            this.$store.dispatch('program/steps/goToNextStep');
          })
          .catch(this.handleErrorAsNotifications, this.$store.dispatch('program/canGoToNextStep', false))
          .finally(() => {
            this.loadingbtn = false;
          });
          return;
      }
      // if(this.selectedStep == 'fertigation'){
        
      //   this.loadingbtn=true;
      //   this.$store.dispatch('program/fertigation/save')
      //     .then(() => {
      //       this.$store.dispatch('program/canGoToNextStep', true);
      //       this.$store.dispatch('program/steps/goToNextStep');
      //     })
      //     .catch(this.handleErrorAsNotifications, this.$store.dispatch('program/canGoToNextStep', false))
      //     .finally(() => { 
      //       this.loadingbtn = false;
      //     });
      //     return;
      // }
    }
  },
  computed : {
    ...mapGetters({
      selectedStep: 'program/steps/selected',
      currentStep: 'program/steps/current',
      program: 'program/data',
      generalSettings: 'program/general-settings/form',
      steps: 'program/steps/data',
      isFinished: 'program/isFinished',
      tanks: 'program/fertigation/tanks',
    }),

    isNextStepAvailable() {
      const next_step = this.$store.getters['program/steps/getNextStep']();
      const next_step_obj = this.steps.find(n => n.key === next_step);
      return next_step_obj && next_step_obj.active;
    }
  },
  created() {
    this.sync(this.$route.params.programId);
    this.$store.dispatch('user/availableReports');
    this.$store.dispatch('program/getPdfForProgram', this.$route.params.programId);
  },
  beforeDestroy () {
    this.$store.dispatch('program/destroyState');
  },
  beforeRouteUpdate(to, from, next) {
    this.sync(to.params.programId);
    next();
  },
  watch: {
    'selectedStep': function (to, from) {

      const prev_step = this.$store.getters['program/steps/getPrevStep']();
      const next_step = this.$store.getters['program/steps/getNextStep']();

      const prev_index = this.steps.findIndex(n => n.key === prev_step);
      const next_index = this.steps.findIndex(n => n.key === next_step);

      if(next_index > prev_index) {
        this.transition = 'fade-move-left';
      } else {
        this.transition = 'fade-move-right';
      }
    }
  },
  components: {
    StepsBar,
    GeneralSettings,
    Tests,
    AdjustedValues,
    BaseDressing,
    Fertigation,
    FertilizerSchedule,
    Blend,
    Result,
    Liming,
    Gdd,
  }
}
</script>

<style lang="scss" scoped>
.program {

  width: 100%;
  min-height: 100%;
  

  display: flex;
  flex-direction: column;

  .single-step, .heading > .buttons {
    margin: 0 auto;
    max-width: 960px;
    padding-bottom: 48px;
  }

  .heading {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    min-height: 80px;
    background-color: #fff;
    border-right: 1px solid #E4E5E6;
    border-left: 1px solid #E4E5E6;
    padding: 16px 16px 0 16px;
    .buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      padding: 0;
      width: 100%;
      > * {
        margin-left: 20px;
      }
    }
  }

  .dummy-heading {
    min-height: 80px;
  }

  .flow {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .steps {
      padding: 16px;
      border: 1px solid #E4E5E6;
      border-top: 0;
      background-color: #fff;
      border-radius: 0 0 5px 5px;
      flex-grow: 1;
      &::v-deep {
        > div {
          > .heading {
            h2 {
              color: #2c3e50;
              margin: 32px 0;
              @media (max-width: 768px) {
                margin: 16px 0;
              }
            }
          }
          .a-rows {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            .a-row {
              width: 100%;
            }
          }
        }
      }
    }
  }
  @media (max-width:768px) {
    .heading {
      h1 {
        margin-top: 0;
        margin-bottom: 16px;
      }
      .buttons {
        display: none;
      }
    }
    .flow {
      .steps {
        padding: 8px;
      }
    }
  }
}
</style>
